import styled from 'styled-components'

export const SelectWrapper = styled.div`
  width: 100%;
  .select {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #212226;
    border-radius: 20px;
    padding: 10px 15px;
    height: 40px;

    border: 1px solid #2f2f33;

    .currency {
      display: flex;
      align-items: center;
      color: #ffffff;
      font-family: 'Inter';
      font-style: normal;
      font-weight: 500;
      font-size: 13px;

      .coin-image {
        height: 18px;
        width: 18px;
        margin-right: 9px;
      }
    }

    svg {
      color: #ffffff;
      margin-left: 10px;
    }
  }
`
